import React from 'react'
import microphoneGray from '../../../../images/ready-module/microphone-gray.svg'

export default function Microphone() {
  return (
    <div className="instruction-image"><img src={microphoneGray} alt=""/></div>
  )
}
